!((document, Drupal, $, once) => {
  'use strict';

  /**
   * Drop-down menu using Superfish.
   */
  Drupal.behaviors.navDropDown = {
    attach: context => {
      $(once('navDropDown', '.js-nav-drop-down-menu', context))
        .each(function() {
          const $navDropDown = $(this);
          // Animation causes drop-down to flicker in IE and Safari.
          $navDropDown.superfish({
            hoverClass: 'sf-hover',
            delay: 0,
            autoArrows: false,
            speed: 0,
            disableHI: true,
          });
        });
    },
  };
})(document, Drupal, jQuery, once);
